<template>
  <a-form-item label="批次">
    <a-select :style="{width:type=='select'?'180px':'100%'}" @change="change" v-model:value="batchSn" :mode="mode" placeholder='请选择批次'>
      <a-select-option value="" v-if="type=='select'">全部</a-select-option>
      <a-select-option v-for='item in list' :value="item.batch_sn" :key='item.batch_sn'>{{item.batch_sn}}
      </a-select-option>
    </a-select>
  </a-form-item>
</template>

<script>
  import { code_batchs } from "@/api/qrcode";
  import { onMounted, ref, watch } from "vue";
  import { iscode } from "@/utils/app";
  export default {
    props: {
      batch_sn: String,
      type: String,
      mode: {
        type: String,
          default(){ 
          return ''
        }
      },
    },
    name: "normalBatchs",
    setup(props, { emit }) {
      const list = ref([]);
      const batchSn = ref();
      const getCodeBatchsOptions = async () => {
        let res = await code_batchs().then((res) => res.data);
        if (iscode(res)) {
          list.value = res.data;
        }
      };
      let watcher = watch(props, () => {
        if (props.batch_sn) {
          if (!watcher) return;
          batchSn.value = props.batch_sn;
          watcher = null;
        }
      });
      const change = (e) => {
        console.log(e,222)
        if (e instanceof Array) {
          var batchs = []
          list.value.forEach(element => {
            e.forEach(v => {
              if (v == element.batch_sn) {
                batchs.push(element)
              }
            })
          });
          emit("change", batchs);
        } else {
          list.value.forEach(element => {
            if (element.batch_sn == e) {
              
              emit("change", element);
            }
          });
        }
        emit("update:value", e);
      };
      onMounted(() => {
        getCodeBatchsOptions();
      });
      return {
        list,
        change,
        batchSn,
      };
    },
  };
</script>